module.exports = new __parcel__URL__("plans-empty.7a647633.svg").toString();